/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _assign = _interopRequireDefault(require("../../../common/assign"));
function Arrow(props) {
  var style = (0, _assign.default)({}, props.style);
  var wrapperStyle = (0, _assign.default)({}, props.position);
  var arrowSize = {
    height: props.size,
    width: props.size
  };
  (0, _assign.default)(style, arrowSize);
  var wrapperSize = 2 * (0.5 * props.size * Math.pow(2, 0.5));
  if (wrapperSize) {
    wrapperStyle.width = wrapperSize;
    wrapperStyle.height = wrapperSize;
  }
  return _react.default.createElement("div", {
    className: props.wrapperClassName,
    style: wrapperStyle
  }, _react.default.createElement("div", {
    className: props.className,
    style: style
  }));
}
Arrow.propTypes = {
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  size: _propTypes.default.number,
  position: _propTypes.default.shape({
    top: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
    left: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
  })
};
var _default = Arrow;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/Overlay/src/Arrow.js
// module id = 722
// module chunks = 0